// Embed detection, partner identification, and chrome hiding. When up-spa runs
// inside a partner iframe, main.ts calls markEmbedded() so global CSS can hide
// chrome a partner shouldn't show — top navigation, footer, cookie consent (see
// App.vue). The Retail Trust auth handshake itself lives in partnerEmbed.ts.

export const isEmbedded = (): boolean => window.parent !== window.self;

export const RETAIL_TRUST = "retailtrust";
export const ZURICH = "zurich";

// The first label of the host we are served from — the same rule getBranding()
// uses to derive `subdomain`, but computed directly rather than read from the
// store, because main.ts needs it at boot and that request has not resolved yet
// (the store still holds its "app" default at that point).
export const currentSubdomain = (): string =>
  window.location.host.split(".").filter((part) => part !== "www")[0] ?? "";

// Which partner's iframe we are in, or null for a top-level load or an embed we
// do not recognise.
//
// Everything embed-specific hangs off this rather than off isEmbedded() alone.
// Treating "in an iframe" as "is Retail Trust" is what put Retail Trust's footer
// in Zurich's embed and ran Retail Trust's handshake against a parent that was
// never going to answer it — the member then waited out a 40s timeout and got an
// auth error instead of a sign-in screen.
export const embedPartner = (): string | null => {
  if (!isEmbedded()) return null;
  const subdomain = currentSubdomain();
  return subdomain === RETAIL_TRUST || subdomain === ZURICH ? subdomain : null;
};

export const isZurichEmbed = (): boolean => embedPartner() === ZURICH;

// Mark the document as embedded so global CSS can hide chrome a partner shouldn't
// show (top navigation, footer, cookie banner — see App.vue). Idempotent.
export const markEmbedded = (): void => {
  document.documentElement.classList.add("is-embedded");
};
